<template>
  <div v-if="roles.length" class="current-roles">
    <span class="current-roles__label">{{ t('header.myRoles') }}</span>
    <div class="current-roles__list" role="list" :aria-label="contextName ? t('header.rolesIn', { context: contextName }) : t('header.myRoles')" tabindex="0">
      <span v-for="role in roles.slice(0, 2)" :key="role" class="current-roles__pill" role="listitem" :title="role === 'systemAdmin' ? t('header.platformRole') : t('header.rolesIn', { context: contextName })">{{ t(`header.roleLabels.${role}`) }}</span>
      <v-menu v-if="roles.length > 2" location="bottom end" scroll-strategy="block">
        <template #activator="{ props }"><button v-bind="props" type="button" class="current-roles__pill current-roles__more" :aria-label="t('header.showAllRoles', { count: roles.length })">+{{ roles.length - 2 }}</button></template>
        <v-card class="pa-4" max-width="320">
          <strong>{{ contextName ? t('header.rolesIn', { context: contextName }) : t('header.myRoles') }}</strong>
          <div class="current-roles__expanded" role="list" :aria-label="t('header.myRoles')"><span v-for="role in roles" :key="role" class="current-roles__pill" role="listitem">{{ t(`header.roleLabels.${role}`) }}</span></div>
        </v-card>
      </v-menu>
    </div>
  </div>
</template>
<script setup lang="ts">
import { useI18n } from 'vue-i18n'
defineProps<{ roles: string[]; contextName: string }>()
const { t } = useI18n()
</script>
<style scoped>
.current-roles { display:flex; align-items:center; gap:8px; margin-inline:10px; min-width:0; }
.current-roles__label { font-size:.65rem; color:var(--cs-soft-white); white-space:nowrap; }
.current-roles__list { display:flex; flex-wrap:wrap; justify-content:flex-end; gap:4px; max-width:230px; max-height:54px; overflow:auto; padding:2px; }
.current-roles__more { cursor:pointer; font-weight:700; }
.current-roles__expanded { display:flex; flex-wrap:wrap; gap:6px; margin-top:12px; }
.current-roles__more:focus-visible, .current-roles__list:focus-visible { outline:2px solid var(--cs-electric); outline-offset:2px; border-radius:5px; }
.current-roles__pill { display:inline-flex; align-items:center; white-space:nowrap; border:1px solid var(--cs-logo-violet); border-radius:999px; padding:2px 8px; font-size:.68rem; line-height:1.4; color:var(--cs-soft-white); background:var(--cs-indigo); }
@media(max-width:959px) {
  .current-roles { justify-content:flex-end; width:100%; margin:0; padding:0 12px; height:32px; }
  .current-roles__list { max-width:none; flex-wrap:nowrap; justify-content:flex-start; overflow-x:auto; }
}
</style>
